import { Container } from 'hypo-container';

import { HttpTransport } from '@estee/elc-http-transport';
import { getDecorators } from '@estee/elc-service';

import { LoyaltyApiSdk } from '~api/LoyaltyApiSdk';
import { Config } from '~domain/entities/Config';
import LoyaltyInfo from '~domain/entities/LoyaltyInfo';
import LoyaltyTierController from '~exported/loyalty-tier/LoyaltyTierController';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { LoyaltyRepository } from '~repositories/LoyaltyRepository';

import { LoyaltyService } from './LoyaltyService';
import { ServiceBusController } from './ServiceBusController';

export const diContainer = new Container();
export const serviceNames = {
    config: 'CONFIG',
    configRepository: 'CONFIG_REPOSITORY',
    httpTransport: 'HTTP_TRANSPORT',
    loyaltyApiSdk: 'LOYALTY_API_SDK',
    loyaltyInfo: 'LOYALTY_INFO',
    loyaltyRepository: 'LOYALTY_REPOSITORY',
    loyaltyService: 'LOYALTY_SERVICE',
    loyaltyTierViewController: 'LOYALTY_TIER_VIEW_CONTROLLER',
    serviceBusController: 'SERVICE_BUS_CONTROLLER'
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setConfig = (configJSON: any) => {
    diContainer.config = configJSON;
};

diContainer
    .register(serviceNames.config, (c) => {
        const appConfig = c.config;

        return new Config(appConfig);
    })
    .register(serviceNames.loyaltyService, (c) => {
        const service = new LoyaltyService((config) => {
            setConfig(config);
            const serviceBus = c.get(serviceNames.serviceBusController);

            return serviceBus;
        });

        return service;
    })
    .register(serviceNames.httpTransport, () => new HttpTransport())
    .register(serviceNames.loyaltyInfo, () => new LoyaltyInfo())
    .register(serviceNames.configRepository, (c) => {
        const entity = c.get(serviceNames.config);

        return new ConfigRepository(entity);
    })
    .register(serviceNames.loyaltyRepository, (c) => {
        const api = c.get(serviceNames.loyaltyApiSdk);

        return new LoyaltyRepository(api);
    })
    .register(serviceNames.loyaltyTierViewController, (c) => {
        const repository = c.get(serviceNames.loyaltyRepository);

        return new LoyaltyTierController(repository);
    })
    .register(serviceNames.serviceBusController, (c) => new ServiceBusController())
    .register(serviceNames.loyaltyApiSdk, (c) => {
        const transport = c.get(serviceNames.httpTransport);

        return new LoyaltyApiSdk(transport);
    });

const { lazyInject } = getDecorators(diContainer);

export { lazyInject };
